module.exports = __webpack_public_path__ + "static/media/image-card-9.efcdae50.png";